module.exports = __webpack_public_path__ + "static/media/Patreon1_Support_512_esp.6faa3f89.png";